import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<select class={{this.qlClass}} ...attributes>\n  {{#if (has-block)}}\n    {{yield}}\n  {{else}}\n    {{#each @values as |value|}}\n      <option selected={{eq @selected value}} value={{if value value}}></option>\n    {{/each}}\n  {{/if}}\n</select>\n");

class QuillToolbarSelectComponent extends Component {
  get qlClass() {
    if (this.args.type) {
      return `ql-${this.args.type}`;
    }
    return null;
  }
}
setComponentTemplate(TEMPLATE, QuillToolbarSelectComponent);

export { QuillToolbarSelectComponent as default };
//# sourceMappingURL=select.js.map
